import {
  downloadExportedAgingBalance,
  getAgingBalance,
  getAgingBalanceResumeList,
  downloadExportedAgingBalanceResume
} from 'src/services/accountingService';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import { SnackBarVariants } from 'src/utils/constants/common';
import {
  selectAgingBalanceQueryOptions,
  selectAgingBalanceResumeQueryOptions
} from '../selectors/accountingSelector';
import { showMessage } from './snackBarActions';

export const LOAD_AGING_BALANCE = asyncActionCreator('LOAD_AGING_BALANCE');
export const LOAD_AGING_BALANCE_RESUME_LIST = asyncActionCreator(
  'LOAD_AGING_BALANCE_RESUME_LIST'
);
export const DOWNLOAD_AGING_BALANCE = asyncActionCreator(
  'DOWNLOAD_AGING_BALANCE'
);
export const CLEAR_AGING_BALANCE = 'CLEAR_AGING_BALANCE';
export const SAVE_AGING_BALANCE_OPTIONS = 'SAVE_AGING_BALANCE_OPTIONS';
export const CLEAR_AGING_BALANCE_OPTIONS = 'CLEAR_AGING_BALANCE_OPTIONS';

export const SAVE_AGING_BALANCE_RESUME_OPTIONS =
  'SAVE_AGING_BALANCE_RESUME_OPTIONS';
export const CLEAR_AGING_BALANCE_RESUME_OPTIONS =
  'CLEAR_AGING_BALANCE_RESUME_OPTIONS';
export const CLEAR_AGING_BALANCE_RESUME = 'CLEAR_AGING_BALANCE_RESUME';
export const DOWNLOAD_AGING_BALANCE_RESUME = asyncActionCreator(
  'DOWNLOAD_AGING_BALANCE_RESUME'
);

function getOptions(getState, sendLimit = true) {
  const queryOpts = selectAgingBalanceQueryOptions(getState());

  const reqOptions = {};

  if (queryOpts.page > 0) {
    reqOptions.offset =
      queryOpts.page * Number(process.env.REACT_APP_TABLE_SIZE);
  }
  if (queryOpts.balanceType) {
    reqOptions.balanceType = queryOpts.balanceType;
  }
  if (queryOpts.name) {
    reqOptions.name = queryOpts.name;
  }
  if (queryOpts.date) {
    reqOptions.date = queryOpts.date;
  }
  if (queryOpts.legalStatus) {
    reqOptions.legalStatus = queryOpts.legalStatus;
  }
  if (sendLimit) {
    reqOptions.limit = queryOpts.limit;
  }
  return reqOptions;
}

function getResumeOptions(getState) {
  const queryOpts = selectAgingBalanceResumeQueryOptions(getState());
  const reqOptions = {};
  if (queryOpts.date) {
    reqOptions.date = queryOpts.date;
  }
  return reqOptions;
}

export const clearOptions = () => dispatch => {
  dispatch({ type: CLEAR_AGING_BALANCE_OPTIONS });
};

export const clearResumeOptions = () => dispatch => {
  dispatch({ type: CLEAR_AGING_BALANCE_RESUME_OPTIONS });
};

export const loadAgingBalance = options => async (dispatch, getState) => {
  try {
    dispatch({ type: LOAD_AGING_BALANCE.start });

    dispatch({
      type: SAVE_AGING_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptions(getState);

    const data = await getAgingBalance(reqOptions);

    return dispatch({
      type: LOAD_AGING_BALANCE.success,
      ...data
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_AGING_BALANCE.failure });
  }
};

export const loadAgingBalanceResumeList = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: LOAD_AGING_BALANCE_RESUME_LIST.start });
    dispatch({
      type: SAVE_AGING_BALANCE_RESUME_OPTIONS,
      options
    });
    const reqOptions = getResumeOptions(getState);
    const data = await getAgingBalanceResumeList(reqOptions);
    return dispatch({
      type: LOAD_AGING_BALANCE_RESUME_LIST.success,
      ...data
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_AGING_BALANCE_RESUME_LIST.failure });
  }
};

export const downloadExcelAgingBalance = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({
      type: DOWNLOAD_AGING_BALANCE.start
    });

    dispatch({
      type: SAVE_AGING_BALANCE_OPTIONS,
      options
    });

    const reqOptions = getOptions(getState, false);
    await downloadExportedAgingBalance(reqOptions);

    return dispatch({
      type: DOWNLOAD_AGING_BALANCE.success
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: DOWNLOAD_AGING_BALANCE.failure });
  }
};

export const downloadExcelAgingBalanceResume = options => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: DOWNLOAD_AGING_BALANCE_RESUME.start });

    dispatch({
      type: SAVE_AGING_BALANCE_RESUME_OPTIONS,
      options
    });

    const reqOptions = getResumeOptions(getState, false);
    await downloadExportedAgingBalanceResume(reqOptions);
    return dispatch({
      type: DOWNLOAD_AGING_BALANCE_RESUME.success
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: DOWNLOAD_AGING_BALANCE_RESUME.failure });
  }
};
